export default {
  STUDENT: "student",
  PAYER: "payer",
};
